<template>
  <div>
    <pop-modal :visible="visible" title="清单填开" :width="1280" :height="100" @cancel="handelCancel">
      <div class="wrap">
        <div class="header">
          <div>请认真核对发票<span>种类、代码、号码</span>是否一致，如不一致请更换纸质发票</div>
          <!-- <div>喇叭</div> -->
        </div>
        <div class="main">
          <div class="main-top">
            <div></div>
            <div>
              <a-button type="primary" ghost>清单导入</a-button>
              <a-button type="primary" ghost @click="transform()">转发票</a-button>
              <a-button type="primary" ghost @click="complete()">完成</a-button>
            </div>
          </div>
          <div class="main-cont">
            <div class="cont-invoice">
              <div class="invoice-no">
                <span class="taxBillCode">{{ kpdate.taxBillCode }}</span>
                <span class="taxBillNo">{{ kpdate.taxBillNo }}</span>
              </div>
              <div class="invoice-table">
                <div class="table-header tab">
                  <div style="flex: 0.3">
                    <input type="checkbox" name="" id="" v-model="allChecked" @change="checkAll()" />
                  </div>
                  <div style="flex: 3">货物或应税劳务、服务名称</div>
                  <div style="flex: 1">规格型号</div>
                  <div style="flex: 1">单位</div>
                  <div style="flex: 1">数量</div>
                  <div style="flex: 1.5">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1">税率</div>
                  <div style="flex: 1">税额</div>
                </div>
                <div
                  class="table-content tab"
                  :class="data.isDiscount ? 'red' : ''"
                  v-for="(data, i) in detailedList"
                  :key="i"
                >
                  <div style="flex: 0.3; text-align: center">
                    <input type="checkbox" name="" id="" v-model="data.checked" @change="checkChange(data, i)" />
                  </div>
                  <div style="flex: 3">
                    <div class="relative">
                      <input type="text" v-model="data.alias" :readonly="onlyQd" />
                      <a-icon type="plus-square" class="addImg" @click="!onlyQd && showGoods(i)" />
                    </div>
                  </div>
                  <div style="flex: 1">
                    <input type="text" v-model="data.goodsGauge" :readonly="isDisOnly(data, i)" />
                  </div>
                  <div style="flex: 1">
                    <input type="text" v-model="data.goodsUnits" :readonly="isDisOnly(data, i)" />
                  </div>
                  <div style="flex: 1">
                    <input
                      type="number"
                      v-model="data.goodsAmounts"
                      @change="goodsAmountsChange(i)"
                      :readonly="isDisOnly(data, i)"
                    />
                  </div>
                  <div style="flex: 1.5">
                    <input
                      type="number"
                      v-model="data.goodsUnitPrice"
                      @change="goodsUnitPriceChange(i)"
                      :readonly="isDisOnly(data, i)"
                    />
                  </div>
                  <div style="flex: 1.5">
                    <input
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      :readonly="isDisOnly(data, i)"
                    />
                  </div>
                  <div style="flex: 1">
                    <select v-model="data.goodsTaxRates" @change="rateChange(i)" :disabled="data.goodsName && isDisOnly(data, i)">
                      <option value="0">不征税</option>
                      <option value="0.00">0%</option>
                      <option value="0.03">3%</option>
                      <option value="0.05">5%</option>
                      <option value="0.015">按减1.5%计算</option>
                      <option value="0.09">9%</option>
                      <option value="0.11">11%</option>
                      <option value="0.13">13%</option>
                      <option value="0.16">16%</option>
                      <option value="0.17">17%</option>
                    </select>
                  </div>
                  <div style="flex: 1"><input type="text" v-model="data.taxAmountPayables" readonly /></div>
                </div>
              </div>
            </div>
            <div class="cont-op">
              <a-button type="primary" ghost @click="addList('fp')">增行</a-button>
              <a-button type="primary" ghost @click="delList()">减行</a-button>
              <a-button type="primary" ghost @click="insertList()">插行</a-button>
              <a-button type="primary" ghost @click="discount()">折扣</a-button>
              <a-button type="primary" ghost @click="priceChange()">含税</a-button>
            </div>
          </div>
        </div>
      </div>
    </pop-modal>
    <!-- 折扣弹窗 -->
    <pop-modal :visible="discountShow" :title="`添加折扣`" :width="600" :height="50" @cancel="discountCancel">
      <div class="discountWrap">
        <div class="row">
          <div class="left">已选商品行数</div>
          <div class="right light-blue">{{ selectedData.length }}</div>
        </div>
        <div class="row">
          <div class="left">商品金额</div>
          <div class="right light-blue">{{ disGoodsAmount }}</div>
        </div>
        <div class="row">
          <div class="left">折扣率（%）</div>
          <div class="right">
            <input type="text" placeholder="请输入折扣率" v-model="discountRate" @input="disCRChange" />
          </div>
        </div>
        <div class="row">
          <div class="left">折扣金额（￥）</div>
          <div class="right">
            <input type="text" placeholder="请输入折扣金额" v-model="discountAmount" @input="disCAChange" />
          </div>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'center',
          zIndex: 1,
        }"
      >
        <a-button style="margin: 0 20px" type="primary" :disabled="isDiscountSubmit" @click="disSubmit">确认</a-button>
        <a-button style="margin: 0 20px" type="primary" @click="discountCancel">取消</a-button>
      </div>
    </pop-modal>
    <!--客户编码弹窗-->
    <custom-no ref="CustomNoForm" @emitRowKey="emitRowCustom" width="900px" :height="100"></custom-no>
    <!-- 商品编码弹窗 -->
    <goods-no ref="GoodsNoForm" @emitRowKey="emitRowGoods" width="900px" :height="100"></goods-no>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, checkObjectOfNull, keepTwoDecimalFull } from '@/utils/util'
import { mapGetters, mapActions } from 'vuex'
import CustomNo from '../../systemSet/customNo.vue'
import GoodsNo from '../../systemSet/goodsNo.vue'

export default {
  components: {
    CustomNo,
    GoodsNo,
  },
  data() {
    return {
      visible: false,
      discountShow: false,
      kpdate: {
        taxClass: 0,
        isShow: false,
        icManageId: '',
        taxBillCode: '',
        taxBillNo: '',
      },
      enterprise: {
        buyerAccounts: '',
        buyerAddress: ' ',
        buyerName: '',
        buyerTaxpayerId: '',
        domainName: '',
        enterpriseAccounts: '',
        enterpriseAddress: '',
        enterpriseName: '',
        enterpriseTaxpayerId: '',
        taxBillDate: '',
        drawer: '',
      },
      selectedData: [],
      allChecked: false,
      detailId: '',
      onlyQd: '',
      detailedList: [],
      price: 'taxfree',
      moneyAmount: '',
      rateMoneyAmount: '',
      moneyAndRate: '',
      // 折扣
      discountRate: '', // 折扣税率
      discountAmount: '', // 折扣金额
      disGoodsAmount: 0, // 商品金额
      isDiscountSubmit: false,
    }
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA', 'ENTERPRISE']),
  },
  methods: {
    async show(params) {
      this.visible = true
      this.enterprise = params.enterprise
      this.detailedList = params.kpList
      this.kpdate = params.kpdate
      this.initSelected()
      // await this.fptk()
      // this.generateInvoice()
    },
    handelCancel() {
      this.visible = false
      this.delUnGoods()
    },
    // 删除未填写的商品
    delUnGoods() {
      this.detailedList.filter((v) => v.alias)
    },
    discountCancel() {
      this.discountShow = false
    },
    // 多选
    checkAll() {
      if (this.allChecked) {
        this.detailedList.forEach((data, i) => {
          data.checked = true
          this.selectedData.push(data)
        })
      } else {
        this.initSelected()
        this.detailedList.forEach((v) => (v.checked = false))
      }
    },
    checkChange(data, i) {
      if (data.checked) {
        // data.checked = true
        this.selectedData.push(data)
      } else {
        // data.checked = false
        this.selectedData = this.selectedData.filter((v) => v.checked)
      }
      this.allChecked = this.selectedData.length === this.detailedList.length
    },
    // 初始化全选
    initSelected() {
      this.selectedData = []
      this.allChecked = false
    },
    // 添加行
    addList() {
      this.detailedList.splice(this.detailedList.length, 0, this.initFP())
    },
    // 删除行
    delList(type) {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请勾选要删除的商品行',
        })
        return
      }
      if (this.selectedData.every((v) => v.isDiscount)) {
        this.$info({
          title: '提示',
          content: '您将要删除的商品行为折扣行，删除此行将取消上行商品的折扣。您要继续吗？',
          onOk: () => {
            this.deleSelf(this.detailedList)
            this.initSelected()
            this.amountMoney()
          },
          onCancel: () => false,
        })
        return
      }
      if (this.selectedData.some((v) => v.isDiscount)) {
        this.$info({
          title: '提示',
          content: '您将要删除的商品行有折扣行，删除此行也可能将删除折扣行。您要继续吗？',
          onOk: () => {
            this.deleSelf(this.detailedList)
            this.initSelected()
            this.amountMoney()
          },
          onCancel: () => false,
        })
        return
      }
      this.deleSelf(this.detailedList)
      this.initSelected()
      this.amountMoney()
    },
    deleSelf(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          if (arr[index + 1] && arr[index + 1].isDiscount && arr[index + 1].isDiscount) arr[index + 1].checked = true
          arr.splice(index, 1)
          this.deleSelf(arr)
        }
      })
    },
    // 插入行
    insertList() {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请先选择要插入行的位置!',
        })
        return
      }
      this.insertSelf(this.detailedList)
      this.initSelected()
      this.amountMoney()
    },
    insertSelf(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          arr.splice(index, 0, this.initFP())
          v.checked = false
          this.insertSelf(arr)
        }
      })
    },
    // 添加折扣
    discount() {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请勾选要进行折扣的商品行',
        })
        return
      }
      if (!this.selectedData.every((v) => v.goodsPriceAmounts)) {
        this.$error({
          title: '提示',
          content: '被折扣商品行中存在金额为空的记录，不能添加折扣',
        })
        return
      }
      if (!this.selectedData.every((v) => v.alias)) {
        this.$error({
          title: '提示',
          content: '被折扣商品行中存在商品为空的记录，不能添加折扣',
        })
        return
      }
      this.disGoodsAmount = this.selectedData.reduce((pre, cur) => {
        return Number(cur.goodsPriceAmounts) + pre
      }, 0)
      this.discountRate = ''
      this.discountAmount = ''
      this.discountShow = true
    },
    disCRChange(v) {
      const value = Number(v.target.value)
      if (value > 100) {
        this.$error({
          title: '错误',
          content: '折扣率不能大于100%',
        })
        this.isDiscountSubmit = true
        return
      }
      this.isDiscountSubmit = false
      this.discountAmount = (value / 100) * Number(this.disGoodsAmount)
    },
    disCAChange(v) {
      const value = Number(v.target.value)
      if (value > this.disGoodsAmounts) {
        this.$error({
          title: '错误',
          content: '折扣金额不能大于被折扣商品合计金额',
        })
        this.isDiscountSubmit = true
        return
      }
      this.isDiscountSubmit = false
      this.discountRate = value / Number(this.disGoodsAmounts)
    },
    isDisOnly(data, i) {
      return data.isDiscount || (this.detailedList[i + 1] && this.detailedList[i + 1].isDiscount)
    },
    // 添加折扣确认
    disSubmit() {
      this.discountInsert(this.detailedList)
      this.initSelected()
      this.discountCancel()
    },
    // 插入添加折扣
    discountInsert(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          const fpData = this.initFP('discount')
          const discountRate = this.discountRate / 100
          fpData.alias = v.alias
          fpData.goodsPriceAmounts = -Math.floor(v.goodsUnitPrice * discountRate * 100) / 100 // 金额 = 父级单价 * 折扣率
          fpData.goodsTaxRates = v.goodsTaxRates // 税率
          fpData.taxAmountPayables = -Math.floor(v.goodsUnitPrice * discountRate * v.goodsTaxRates * 100) / 100 // 税额 = 当前金额 * 当前税率 向下取整保留两位小数
          arr.splice(index + 1, 0, fpData)
          v.checked = false
          this.discountInsert(arr)
        }
      })
    },
    // 是否含税切换
    priceChange() {
      const list = this.detailedList
      if (list == null || list.length < 1) {
        this.$info({
          title: '提示',
          content: '数据为空!',
        })
        return
      }
      this.price = this.price === 'taxfree' ? 'unit' : 'taxfree'
      for (let i = 0; i < list.length; i++) {
        if (list[i].goodsTaxRates !== null || list[i].goodsTaxRates !== 0) {
          const num = (100 + list[i].goodsTaxRates * 100) / 100
          const s = list[i].goodsUnitPrice
          // 第一个计算式为不含税，第二个为含税
          // 如果列表为折扣列表，则不进行单价计算
          if (!list[i].isDiscount) {
            list[i].goodsUnitPrice =
              this.price === 'taxfree' ? Number((s * num).toFixed(4)) : Number((s / num).toFixed(4))
          }
          this.calcPriceAmounts(i)
        }
      }
      this.amountMoney()
    },
    // 初始化发票
    initFP(type) {
      const studentReportTaxBList = {
        goodsCodeId: '',
        goodsCodeName: '',
        goodsName: '',
        goodsGauge: '',
        goodsUnits: '',
        goodsAmounts: '',
        // 不含税单价
        goodsUnitPrice: '',
        // 含税单价
        unitprice: '',
        goodsPriceAmounts: '',
        unitmoney: '',
        goodsTaxRates: '0.13',
        taxAmountPayables: '',
        hasTax: '',
        checked: false, // 是否被选中
        isDiscount: type === 'discount', // 是否为折扣行
      }
      return studentReportTaxBList
    },
    // 获取开票相关信息
    async fptk() {
      const params = parseParam({
        taxClass: this.kpdate.taxClass,
        icManageId: this.kpdate.icManageId ? this.kpdate.icManageId : '',
      })
      const res = await this.$http.post(`${Urls.openInvoice}&${params}`)
      if (res) {
        this.kpdate.icManageId = res.icManageId
        this.kpdate.taxBillNo = res.taxBillNo
        this.kpdate.taxBillCode = res.taxBillCode
      }
    },
    // 获取 enterprise 信息
    async generateInvoice() {
      const task = await this.getTasksBySeq(4)
      if (checkObjectOfNull(task)) {
        return
      } else {
        this.taskData = task
      }
      const params = parseParam({
        moduleId: this.taskData.id,
        icManageId: this.kpdate.icManageId,
        taxBillNo: this.kpdate.taxBillNo,
      })
      const res = await this.$http.post(`${Urls.generateInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.detailId = res.detailId
        this.enterprise = res.enterprise
        this.enterprise.domainName = this.ENTERPRISE.domainName
      }
    },
    // 显示客户编码模块
    showkehu() {
      this.$refs.CustomNoForm.show('module')
    },
    emitRowCustom(val) {
      this.$refs.CustomNoForm.handelCancel()
      const data = val[0]
      this.enterprise.buyerName = data.name
      this.enterprise.buyerTaxpayerId = data.taxPayerId
      this.enterprise.buyerAddress = data.address
      this.enterprise.buyerAccounts = data.accounts
      this.$forceUpdate()
    },
    // 显示商品编码模块
    showGoods(index, type) {
      if (type === 'qd') {
        this.goodModalShow = true
        this.goodsIndex = index
      } else {
        this.$refs.GoodsNoForm.show('module')
        this.goodsIndex = index
        // if (this.detailedList[0].alias === '(详见销货清单)') {
        //   this.$message.warning({ title: '提示', content: '请到清单里面进行操作!' })
        // } else {
        //   this.$refs.GoodsNoForm.show('module')
        //   this.goodsIndex = index
        // }
      }
    },
    emitRowGoods(val) {
      this.$refs.GoodsNoForm.handelCancel()
      const data = val[0]
      this.detailedList[this.goodsIndex].goodsAmounts = null
      this.detailedList[this.goodsIndex].goodsName = data.name
      this.detailedList[this.goodsIndex].goodsCodeId = data.goodsCodeId
      this.detailedList[this.goodsIndex].goodsGauge = data.guiGe
      this.detailedList[this.goodsIndex].goodsUnits = data.units
      this.detailedList[this.goodsIndex].goodsUnitPrice = parseFloat(data.unitPrice ? data.unitPrice : '0.00')
      this.detailedList[this.goodsIndex].goodsTaxRates = parseFloat(data.taxRate)
      this.detailedList[this.goodsIndex].haveTax = data.haveTax
      this.detailedList[this.goodsIndex].alias = '*' + data.goodsCodeName + '*' + data.name
    },
    /**
     * 数量变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsAmountsChange(i) {
      const listItem = this.detailedList[i]
      // 单价 和金额为空时 不做操作
      if (!listItem.goodsUnitPrice && !listItem.goodsPriceAmounts) return
      if (listItem.goodsUnitPrice == null && listItem.goodsPriceAmounts != null) {
        // 单价为空 金额不为空 计算单价
        this.calcUnitPrice(i)
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 单价变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsUnitPriceChange(i) {
      const listItem = this.detailedList[i]
      // 数量 和 金额 为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsPriceAmounts) return
      // 数量为空 金额不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsPriceAmounts != null) {
        this.calcAmounts(i) // 计算数量
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 金额改变
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables税额   goodsTaxRates 税率
     * @param i
     */
    taxAmountPayablesChange(i) {
      const listItem = this.detailedList[i]
      // 数量 和单价为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsUnitPrice) return
      // 数量为空 单价不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsUnitPrice != null) {
        this.calcAmounts(i) // 计算数量
      }
      listItem.goodsPriceAmounts = Number(listItem.goodsPriceAmounts).toFixed(2) // 转换金额为小数点后两位
      this.calcUnitPrice(i) // 计算单价
      this.rateChange(i)
      this.amountMoney()
    },
    // 计算数量
    calcAmounts(i) {
      const listItem = this.detailedList[i]
      listItem.goodsAmounts = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsUnitPrice) // 计算数量
    },
    // 计算单价
    calcUnitPrice(i) {
      const listItem = this.detailedList[i]
      listItem.goodsUnitPrice = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsAmounts).toFixed(2) // 计算单价
    },
    // 计算金额
    calcPriceAmounts(i) {
      const listItem = this.detailedList[i]
      const calcItem = listItem.isDiscount ? this.detailedList[i - 1] : listItem
      listItem.goodsPriceAmounts = keepTwoDecimalFull(calcItem.goodsUnitPrice * calcItem.goodsAmounts).toFixed(2) // 计算金额
    },
    // 计算税额
    rateChange(i) {
      const listItem = this.detailedList[i]
      const calcItem = listItem.isDiscount ? this.detailedList[i - 1] : listItem
      if (this.price === 'taxfree') {
        listItem.taxAmountPayables = keepTwoDecimalFull(calcItem.goodsPriceAmounts * calcItem.goodsTaxRates).toFixed(2) // 税额 等于金额*税率
      } else {
        // 税额为含税时应该计算不含税金额的税率
        const num = (100 + calcItem.goodsTaxRates * 100) / 100
        const s = calcItem.goodsUnitPrice
        const goodsUnitPrice = keepTwoDecimalFull(s / num).toFixed(2)
        const goodsPriceAmounts = (Number(goodsUnitPrice) * listItem.goodsAmounts).toFixed(2)
        listItem.taxAmountPayables = (Number(goodsPriceAmounts) * calcItem.goodsTaxRates).toFixed(2)
      }
    },
    // 计算总额
    amountMoney() {
      this.moneyAmount = 0
      this.rateMoneyAmount = 0
      this.moneyAndRate = 0
      for (let i = 0; i < this.detailedList.length; i++) {
        if (this.price === 'taxfree') {
          this.moneyAmount += Number(this.detailedList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.detailedList[i].taxAmountPayables)
        } else {
          this.moneyAmount += Number(this.detailedList[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.detailedList[i].taxAmountPayables)
        }
      }
      if (this.price === 'taxfree') {
        this.moneyAndRate = Number((this.moneyAmount + this.rateMoneyAmount).toFixed(2))
      } else {
        this.moneyAndRate = Number(this.moneyAmount.toFixed(2))
      }
    },
    // 确认完成 发票转换成清单
    complete() {
      this.$emit('complete', this.detailedList)
      this.handelCancel()
    },
    // 转发票 清单转换成发票
    transform() {
      if (this.detailedList.length <= 8) {
        this.$emit('transform', this.detailedList)
        this.detailedList = []
        this.handelCancel()
      } else {
        this.$error({
          title: '警告',
          content: '已超过最大行数',
        })
      }
    },
    ...mapActions('practice', ['getTasksBySeq']),
  },
}
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #000;
}
.header {
  padding: 5px;
  background-color: #5eb2f8;
  color: #fff;
}
.main {
  background-color: #e4e7fa;
  flex: 1;
  .main-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    button {
      margin: 0 5px;
    }
  }
}
.main-cont {
  display: flex;
  flex: 1;
  justify-content: space-around;
  .cont-invoice {
    width: 1057px;
    height: 647px;
    background-image: url(~@/assets/detailed.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 5px;
    position: relative;
    .invoice-header {
      margin-left: 446px;
      margin-top: 35px;
      display: block;
      font-size: 29px;
      font-family: '宋体';
      font-weight: 700;
      border: none;
      color: #9d5426;
    }
    .invoice-no {
      .taxBillCode {
        position: absolute;
        top: 4.4%;
        left: 12%;
        font-size: 16px;
      }
      .taxBillNo {
        position: absolute;
        top: 8.8%;
        left: 12%;
        font-size: 16px;
      }
    }
    .invoice-buyer {
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
      }
      .left {
        margin-left: 236px;
        margin-top: 7px;
        display: inline-block;
        input {
          width: 400px;
        }
      }
      .right {
        display: inline-block;
        margin-left: 27px;
      }
    }
    .invoice-table {
      width: 91.3%;
      height: 531px;
      position: absolute;
      top: 14.7%;
      left: 4.4%;
      overflow: auto;
      .tab {
        display: flex;
        height: 21px;
        > div {
          border: 1px solid #a2ddfb;
          box-sizing: border-box;
          width: 100%;
        }
      }
      .table-header {
        text-align: center;
        background-color: #cee3f4;
      }
      .table-content {
        input[type='text'],
        input[type='number'],
        select {
          width: 100%;
          height: 100%;
          border: none;
          background-color: transparent;
        }
      }
    }
    .invoice-sum {
      font-weight: 500;
    }
    .invoice-taxsum {
      height: 36px;
      line-height: 36px;
      font-weight: 500;
    }
    .invoice-saler {
      display: flex;
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
        height: 23px;
      }
      .left {
        margin-left: 237px;
        margin-top: 2px;
        input {
          width: 400px;
        }
      }
      .right {
        margin-left: 27px;
        width: 380px;
        height: 95px;
        textarea {
          height: 100%;
          width: 100%;
          padding: 0;
        }
      }
    }
    .invoice-footer {
      display: flex;
      align-items: center;
      margin-top: 3px;
      .payee {
        margin-left: 187px;
      }
      .review {
        margin-left: 87px;
      }
      .billing {
        margin-left: 48px;
      }
      input[type='text'] {
        border: 1px solid #a2ddfb;
      }
    }
  }
  .cont-op {
    display: flex;
    flex-direction: column;
    padding: 5px;
    justify-content: center;
    button {
      margin: 5px 0;
    }
  }
}
.discountWrap {
  padding: 5% 10%;
  color: #000;
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    .left,
    .right {
      width: 45%;
      font-size: 16px;
    }
    .left {
      text-align: right;
    }
    .right {
      text-align: left;
    }
  }
}
.addImg {
  position: absolute;
  right: 3px;
  top: 2px;
  width: 18px;
}
.relative {
  position: relative;
}
</style>
<style lang="less">
.wrap {
  .main-top,
  .main-cont {
    .ant-btn-background-ghost {
      background-color: #fff !important;
    }
  }
}
</style>
